import { defineSlotRecipe } from '@chakra-ui/react';
export const tabsRecipe = defineSlotRecipe({
    className: 'tabs',
    slots: ['root', 'list', 'trigger', 'content', 'indicator'],
    base: {
        list: {
            position: 'relative',
        },
        trigger: {
            transition: 'all 0.2s',
        },
    },
    variants: {
        variant: {
            line: {
                list: {
                    borderBottomWidth: '1px',
                    borderColor: 'border',
                },
                trigger: {
                    pb: 3,
                    color: 'navInactive',
                    '--indicator-thickness': '2px',
                    _selected: {
                        color: 'dark',
                        _before: {
                            bg: 'dark',
                            rounded: 'full',
                            '--indicator-color': 'colors.dark',
                        },
                    },
                },
            },
        },
    },
});
